import React, { useState } from 'react';
import { Layout as LayoutTemplate, type LayoutProps } from '@tasama/ui';
import { FeatureFlags, isEnabled } from '@tasama/config';
import { useAuth } from '../hooks/use-auth';
import type { SidebarContentState } from '../types';
import { env } from '../config/env';

export const AccountLayout: React.FC = () => {
  const { error, errorType, clearError } = useAuth();
  const [sidebarContent, setSidebarContent] =
    useState<SidebarContentState>(null);

  const handleStartOnboardingClick = () => {
    // Navigate to onboarding application
    window.location.href = env.ONBOARDING_APP_BASE_URL;
  };

  const handleSetSidebarContent = (content: SidebarContentState) => {
    setSidebarContent(content);
  };

  const handleBackToWebsite = () => {};

  // Layout configuration for the reusable Layout template
  const layoutConfig: LayoutProps = {
    variant: 'accountActivation',
    navigation: {
      showLanguageSwitcher: isEnabled(FeatureFlags.LANGUAGE_SWITCHER),
      onBackToWebsite: handleBackToWebsite,
    },
    stepper: {
      onStartOnboarding: handleStartOnboardingClick,
    },
    sidebarContent:
      sidebarContent && 'title' in sidebarContent ? sidebarContent : undefined,
    customSidebarComponent:
      sidebarContent && 'component' in sidebarContent
        ? sidebarContent
        : undefined,
    content: {
      outletContext: {
        setSidebarContent: handleSetSidebarContent,
      },
    },
    error: {
      show: !!error,
      data: error
        ? {
            type: errorType === 'unauthorized' ? 'unauthorized' : 'error',
            message: error,
            onClear: clearError,
          }
        : undefined,
    },
    layout: {
      maxWidth: 'max-w-[1600px]',
      padding: 'px-[62px] lg:pt-6',
      showSidebar: true,
      showBottomNavigation: false,
    },
    testID: 'account-layout',
  };

  return <LayoutTemplate {...layoutConfig} />;
};
